// Copyright (c) 2017 Deere & Company

export const rgaListFilterOptions = [
    ['warrantyClaimNumber'],
    ['rgaDealer'],
    ['analystId'],
    ['machineSerialNumber'],
    ['rgaStatus'],
    ['engineSerialNumber'],
    ['dtacCaseNumber'],
    ['rgaSubType'],
    ['rgaNumber']
];



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/helpers/rga-list-filter-options.js